'use client';

import React, { useSyncExternalStore } from 'react';
import { apiClient } from '@/lib/apiClient';
import { useCachedQuery } from '@/api/queryCache';
import type { NewsArticlesResponse } from '@/api/news/types';
import NewsArticleCard from '@/components/news/NewsArticleCard';
import { Container, Heading, Section } from '@/components/ds';

const fetchLatest = () =>
  apiClient<object, NewsArticlesResponse>('/v1/landing/news/articles', {
    method: 'GET',
    query: { per_page: '3' },
  });

// L'indirizzo non cambia mai sotto i piedi della 404: nessuna sottoscrizione
const subscribe = () => () => {};
const isUnderNews = () => window.location.pathname.split('/')[1] === 'news';
const onServer = () => false;

/**
 * Le ultime tre news, sotto la 404 di un articolo che non c'è: chi arriva da
 * un link morto o da una condivisione vecchia stava cercando qualcosa da
 * leggere, e l'elenco è a un clic ma questo è a zero. Solo sotto `/news`: la
 * 404 è una pagina sola per tutto il sito, e altrove non fa nessuna chiamata.
 */
export default function NotFoundNewsLatest() {
  const underNews = useSyncExternalStore(subscribe, isUnderNews, onServer);
  const { data } = useCachedQuery(underNews ? 'news-latest' : null, fetchLatest);
  const articles = data?.data ?? [];
  if (articles.length === 0) return null;

  return (
    <Section tone="paper" padding="sm">
      <Container>
        <Heading as="h2" size="sm" className="mb-[clamp(1.25rem,3vw,1.875rem)] text-center">
          Nel frattempo, le ultime news
        </Heading>
        <ul className="grid grid-cols-1 gap-4.5 md:grid-cols-3">
          {articles.map(article => (
            <li key={article.slug} className="flex">
              <NewsArticleCard article={article} className="flex-1" />
            </li>
          ))}
        </ul>
      </Container>
    </Section>
  );
}
